import { User, Holder, Officer } from "../interfaces";

export const asyncMapUserFromFirebase = async (firebaseUser: firebase.User) => {
  const additionalInfo = await firebaseUser.getIdTokenResult();

  const user: User | Holder | Officer = {
    uid: firebaseUser.uid,
    displayName: firebaseUser.displayName,
    email: firebaseUser.email,
    phoneNumber: firebaseUser.phoneNumber,
    photoURL: firebaseUser.photoURL,
    roles: additionalInfo.claims.roles
      ? additionalInfo.claims.roles.split(",")
      : [],
    cityId: additionalInfo.claims.cityId,
  };

  return user;
};
